import React from "react";
import {
  Box,
  Heading,
  Text,
  Image,
  VStack,
  List,
  ListItem,
  ListIcon,
} from "@chakra-ui/react";
import { FaCheckCircle, FaTools } from "react-icons/fa";

const FixLeakyFaucetPage = () => {
  return (
    <Box minH="100vh" bg="white">
      {/* Hero Section */}
      <Box
        bg="white"
        py={{ base: 16, md: 20 }}
        px={{ base: 6, md: 12 }}
        textAlign="center"
      >
        <Heading
          as="h1"
          fontSize={{ base: "4xl", md: "5xl" }}
          fontWeight="800"
          color="gray.900"
          mb={6}
          fontFamily="'Work Sans', sans-serif"
        >
          How to Fix a Leaky Faucet
        </Heading>
        <Text
          fontSize={{ base: "lg", md: "xl" }}
          color="gray.600"
          maxW="2xl"
          mx="auto"
        >
          Is your faucet constantly dripping and driving you crazy? Fixing a
          leaky faucet can save water and reduce your utility bill. Follow this
          step-by-step guide to get your faucet back in working order!
        </Text>
      </Box>

      {/* Content Section */}
      <Box bg="gray.50" py={{ base: 12, md: 16 }} px={{ base: 6, md: 12 }}>
        <Box maxW="1000px" mx="auto">
          {/* Tools & Materials Section */}
          <Box
            mb={12}
            p={8}
            bg="white"
            border="1px solid"
            borderColor="gray.200"
            borderRadius="xl"
            boxShadow="sm"
          >
            <Heading
              as="h2"
              fontSize="2xl"
              mb={4}
              color="gray.900"
              fontWeight="700"
            >
              Tools & Materials You'll Need
            </Heading>
            <List spacing={3}>
              <ListItem color="gray.700">
                <ListIcon as={FaTools} color="orange.500" />
                Adjustable Wrench
              </ListItem>
              <ListItem color="gray.700">
                <ListIcon as={FaTools} color="orange.500" />
                Phillips and Flat-Head Screwdrivers
              </ListItem>
              <ListItem color="gray.700">
                <ListIcon as={FaTools} color="orange.500" />
                Replacement Washers/O-Rings
              </ListItem>
              <ListItem color="gray.700">
                <ListIcon as={FaTools} color="orange.500" />
                Plumber’s Tape
              </ListItem>
            </List>
          </Box>

          {/* Step-by-Step Instructions */}
          <VStack align="start" spacing={8} mb={8}>
            {/* Step 1 */}
            <Box>
              <Heading
                as="h2"
                fontSize="2xl"
                color="gray.900"
                fontWeight="700"
                mb={2}
              >
                Step 1: Turn Off the Water Supply
              </Heading>
              <Text fontSize="lg" color="gray.600" mb={4}>
                Locate the shut-off valves under the sink and turn them
                clockwise to stop the flow of water. If you can’t find the
                valves, turn off the main water supply to your house.
              </Text>
            </Box>

            {/* Step 2 */}
            <Box>
              <Heading
                as="h2"
                fontSize="2xl"
                color="gray.900"
                fontWeight="700"
                mb={2}
              >
                Step 2: Remove the Faucet Handle
              </Heading>
              <Text fontSize="lg" color="gray.600" mb={4}>
                Use a screwdriver to remove the screws holding the faucet handle
                in place. Gently pull the handle off to expose the internal
                parts. Place the handle and screws in a safe place.
              </Text>
            </Box>

            {/* Step 3 */}
            <Box>
              <Heading
                as="h2"
                fontSize="2xl"
                color="gray.900"
                fontWeight="700"
                mb={2}
              >
                Step 3: Inspect and Replace the Washer/O-Ring
              </Heading>
              <Text fontSize="lg" color="gray.600" mb={4}>
                Check the washer or O-ring inside the valve seat. If it’s worn
                out or damaged, replace it with a new one of the same size. This
                is a common cause of leaks and drips.
              </Text>
            </Box>

            {/* Step 4 */}
            <Box>
              <Heading
                as="h2"
                fontSize="2xl"
                color="gray.900"
                fontWeight="700"
                mb={2}
              >
                Step 4: Reassemble the Faucet and Test
              </Heading>
              <Text fontSize="lg" color="gray.600" mb={4}>
                Reassemble the handle and turn the water supply back on. Test
                the faucet to ensure the leak has been fixed. If the leak
                persists, double-check the parts and reassemble again.
              </Text>
            </Box>
          </VStack>
        </Box>
      </Box>

      {/* Final Message Section */}
      <Box
        bg="white"
        py={{ base: 12, md: 16 }}
        px={{ base: 6, md: 12 }}
        textAlign="center"
      >
        <Text
          fontSize={{ base: "xl", md: "2xl" }}
          fontWeight="600"
          color="gray.800"
          maxW="3xl"
          mx="auto"
        >
          Congratulations! You’ve successfully fixed your leaky faucet. If you
          encounter more complex issues, don’t hesitate to call a professional
          plumber.
        </Text>
      </Box>
    </Box>
  );
};

export default FixLeakyFaucetPage;
